import React, { useState, useEffect, useRef } from 'react';
import './css/app.css';
import Nav from './components/nav/Nav';
import Main from './components/main/Main';
import Card from './components/main/Card';
import { CARDS_PER_LEVEL } from './constants';

export const functionContext = React.createContext();

function App() {

  const [selectedLevel, setselectedLevel] = useState(0);

  const [intervalTime, setintervalTime] = useState(5000);
  const [cardsError, setCardsError] = useState(null);
  const [countsError, setCountsError] = useState(null);
  const [levelsError, setLevelsError] = useState(null);
  const [selectedWord, setSelectedWord] = useState('');
  const [selectedLanguage, setSelectedLanguage] = useState('en');
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

  const functionContextValue = {
    changeLevel: changeLevel,
    changeLevelRight: changeLevelRight,
    changeLevelLeft: changeLevelLeft,
    togglecompletedlevel: togglecompletedlevel,
    resetAllLevels: resetAllLevels,
    startInterval : startInterval,
    endInterval : endInterval,
    setintervalTime : setintervalTime,
    selectedWord,
    setSelectedWord,
    selectedLanguage,
    setSelectedLanguage,
  }

  const [allCards, setallCards] = useState([]);
  const cardsRef = useRef([]);

  async function getCards(selectedLevel, signal) {
    try {
      setCardsError(null);
      const res = await fetch(`${apiBaseUrl}/cardrange?level=${selectedLevel}`, { signal });
      if (!res.ok) throw new Error(`cardrange ${res.status}`);
      const cards = await res.json();
      const normalized = (Array.isArray(cards) ? cards : Object.values(cards)).map((card) => ({
        ...card,
        english: card.english ?? card.English,
        german: card.german ?? card.German,
      }));
      setallCards(normalized);
      cardsRef.current = normalized;
    } catch (err) {
      if (err.name === 'AbortError') return;
      setCardsError(err.message || 'Failed to load cards');
      // optionally log err
    }
  }

  useEffect(() => {
    const controller = new AbortController();
    getCards(selectedLevel, controller.signal);
    return () => controller.abort();
  }, [selectedLevel]);

  const [numberOfCards, setnumberOfCards] = useState([]);

  async function getNumberOfCards(signal) {
    try {
      setCountsError(null);
      const res = await fetch(`${apiBaseUrl}/numberofcards`, { signal });
      if (!res.ok) throw new Error(`numberofcards ${res.status}`);
      const numberOfCards = await res.json();
      setnumberOfCards(Object.values(numberOfCards));
    } catch (err) {
      if (err.name === 'AbortError') return;
      setCountsError(err.message || 'Failed to load number of cards');
      // optionally log err
    }
  }

  useEffect(() => {
    const controller = new AbortController();
    getNumberOfCards(controller.signal);
    return () => controller.abort();
    }, []);

    // derive max level from numberOfCards (16 cards per level)
    const totalCards = parseInt(numberOfCards?.[0]?.count || numberOfCards?.count || 0, 10) || 0;
    const calcLevelNumber = Math.max(0, Math.ceil(totalCards / CARDS_PER_LEVEL) - 1);
    
    function changeLevel(levelNumber) {
      // console.log(levelNumber)
      setselectedLevel(levelNumber);
    }

  function changeLevelRight(levelNumber) {
    // console.log(levelNumber)
    // console.log(calcLevelNumber)
    setselectedLevel(levelNumber + (levelNumber >= calcLevelNumber ? + 0 : + 1));
  }

    function changeLevelLeft(levelNumber) {
      // console.log(levelNumber)
      // console.log(calcLevelNumber)
      setselectedLevel(levelNumber + (levelNumber <= 0 ? + 0 : - 1));
    }

  const [allLevelStatus, setallLevelStatus] = useState([]);

  async function getallLevelStatus(signal) {
    try {
      setLevelsError(null);
      const res = await fetch(`${apiBaseUrl}/completedlevels`, { signal });
      if (!res.ok) throw new Error(`completedlevels ${res.status}`);
      const allLevelStatus = await res.json();
      setallLevelStatus(Object.values(allLevelStatus));
    } catch (err) {
      if (err.name === 'AbortError') return;
      setLevelsError(err.message || 'Failed to load level status');
      // optionally log err
    }
  }

  useEffect(() => {
    const controller = new AbortController();
    getallLevelStatus(controller.signal);
    return () => controller.abort();
    }, [selectedLevel]);

  async function togglecompletedlevel(selectedLevel, togglevalue) {
    // console.log("running togglecompletedlevel function")
  try {
    await fetch(`${apiBaseUrl}/togglecompletedlevel?level=${selectedLevel}&boolean=${togglevalue}`,
    {
        method: "PUT",
        headers: { "Content-Length": 0 },
    });
    await getallLevelStatus();
} catch (err) {
  // optionally log err
}
}

async function resetAllLevels() {
  if (!allLevelStatus || !allLevelStatus.length) return;
  try {
    await Promise.all(
      allLevelStatus.map((level) =>
        fetch(`${apiBaseUrl}/togglecompletedlevel?level=${level.level_number}&boolean=false`, {
          method: "PUT",
          headers: { "Content-Length": 0 },
        })
      )
    );
    await getallLevelStatus();
    setselectedLevel(0);
  } catch (err) {
    // optionally log err
  }
}

const [randomIdnumber, setrandomIdnumber] = useState([]);

useEffect(() => {
  generateRandomIdNumber(allCards);
  cardsRef.current = allCards;
  }, [allCards]);

function generateRandomIdNumber(allCardsParam) {

    const sourceCards = allCardsParam && allCardsParam.length ? allCardsParam : cardsRef.current;
    if (!sourceCards || sourceCards.length === 0) return;
    let cardIdArray = [];

   function makeArrayFromDisplayedCards() {
     sourceCards.map(card => {
       cardIdArray.push(card.id)
     })
     }

   makeArrayFromDisplayedCards()

   let luckyCard = cardIdArray[Math.floor(Math.random()*cardIdArray.length)];

  setrandomIdnumber(luckyCard)
}

let appIntervalCards = allCards.map(card => ({...card}));

let appRandomNumber = randomIdnumber;
const [finalIntervalCards, setfinalIntervalCards] = useState([]);

function setupInterval(appRandomNumber) {
  const newInterCards = appIntervalCards.map((card) => {
    if (card.id !== appRandomNumber) {
      return {...card, english: " ", german: " "}
    } else {
      return {...card}
    }
  })
  setfinalIntervalCards(newInterCards)
}

useEffect(() => {
  setupInterval(appRandomNumber);
  }, [appRandomNumber]);

  // console.log("edited final interval cards")
  // console.log(finalIntervalCards)
  // console.log("after edit allCards")
  // console.log(allCards)

const [is_intervalOn, setis_intervalOn] = useState(false);


useEffect(() => {
  setis_intervalOn(false);
  }, []);

  useEffect(() => {
    let interval = null;

    if (is_intervalOn) {
      interval = setInterval(() => {
        generateRandomIdNumber()
      }, intervalTime);
    } else {
     clearInterval(interval);
    }

    return () => clearInterval(interval);

  }, [is_intervalOn, intervalTime]);


function startInterval(time, appIntervalCards) {
  setis_intervalOn(true)
}

function endInterval() {
  setis_intervalOn(false)
}

  const navLoading = !numberOfCards?.length || !allLevelStatus?.length;
  const navNumber = numberOfCards?.[0] || null;

  return (
    <>
{
  (is_intervalOn === true) ? (
    <functionContext.Provider value={functionContextValue}>
    <div id="app-container">
        {cardsError && (
          <div className="error-banner">
            <span>{cardsError}</span>
            <button className="error-retry" onClick={() => getCards(selectedLevel)}>Retry</button>
          </div>
        )}
        {countsError && (
          <div className="error-banner">
            <span>{countsError}</span>
            <button className="error-retry" onClick={() => getNumberOfCards()}>Retry</button>
          </div>
        )}
        {levelsError && (
          <div className="error-banner">
            <span>{levelsError}</span>
            <button className="error-retry" onClick={() => getallLevelStatus()}>Retry</button>
          </div>
        )}
  
        <Nav loading={navLoading} allLevelStatus={allLevelStatus} {...allLevelStatus} selectedLevel={selectedLevel} number={navNumber} />

        <Main randomIdNumber={appRandomNumber} allLevelStatus={allLevelStatus} selectedLevel={selectedLevel} allCards={finalIntervalCards}/>

    </div>
    </functionContext.Provider>
  ) : (
    <functionContext.Provider value={functionContextValue}>
    <div id="app-container">
        {cardsError && (
          <div className="error-banner">
            <span>{cardsError}</span>
            <button className="error-retry" onClick={() => getCards(selectedLevel)}>Retry</button>
          </div>
        )}
        {countsError && (
          <div className="error-banner">
            <span>{countsError}</span>
            <button className="error-retry" onClick={() => getNumberOfCards()}>Retry</button>
          </div>
        )}
        {levelsError && (
          <div className="error-banner">
            <span>{levelsError}</span>
            <button className="error-retry" onClick={() => getallLevelStatus()}>Retry</button>
          </div>
        )}
  
        <Nav loading={navLoading} allLevelStatus={allLevelStatus} {...allLevelStatus} selectedLevel={selectedLevel} number={navNumber} />

        <Main allLevelStatus={allLevelStatus} selectedLevel={selectedLevel} allCards={allCards}/>
        {/* <Main randomIdNumber={randomIdNumber} intervalCards={allCards} allLevelStatus={allLevelStatus} selectedLevel={selectedLevel} allCards={allCards}/> */}

    </div>
    </functionContext.Provider>


  )}
</>

  )
}

export default App;
